import { Popover } from 'antd';

interface ConditionalTooltipProps {
  condition?: boolean;
  content?: string | JSX.Element;
  children?: JSX.Element;
  [x: string]: unknown;
}

const ConditionalToolTip = ({ condition, content, children, ...rest }: ConditionalTooltipProps) => {
  if (condition) {
    return (
      <Popover content={content} {...rest}>
        {children}
      </Popover>
    );
  }
  return children;
};

export default ConditionalToolTip;
